module.exports = __webpack_public_path__ + "img/title2.555c59fd.png";